
import {
    AGENTSURVEYSCREEN_LOAD,
    AGENTSURVEYSCREEN_UNLOAD,
    AGENTSURVEYSCREEN_SET,
} from '../../../../actionDefinitions';

import {
    fetchAgentSurveyFormQuestions,
    _submitAgentSurvey
} from '../../../../api/v3/AgentSurveyApi';

import {
    fetchReasonsForContactForUser,
} from '../../../../api/v3/DataApi';

export function loadAgentSurveyScreen() {
    return dispatch => {
        dispatch(loadAgentSurveyFormQuestions());
        dispatch(loadReasonsForContact());        
    };
}

export function loadAgentSurveyFormQuestions() {
    return dispatch =>
        fetchAgentSurveyFormQuestions()
            .then(payload => dispatch({ type: AGENTSURVEYSCREEN_LOAD, payload: { agentSurveyFormQuestions: payload.result } }))
            .catch(payload => dispatch({ type: AGENTSURVEYSCREEN_LOAD, error: true, payload }))
}

export function loadReasonsForContact() {
    return dispatch =>
        fetchReasonsForContactForUser()
            .then(payload => dispatch({ type: AGENTSURVEYSCREEN_LOAD, payload: { reasonsForContact: payload.result } }))
            .catch(payload => dispatch({ type: AGENTSURVEYSCREEN_LOAD, error: true, payload }))
}

export function submitAgentSurvey(agentSurvey, callBackFunc) {
    return dispatch =>
        _submitAgentSurvey(agentSurvey)
            .then(payload => dispatch({ type: AGENTSURVEYSCREEN_LOAD, payload: { submittedAgentSurvey: payload.result } }))
            .then(() => callBackFunc())
            .catch(payload => dispatch({ type: AGENTSURVEYSCREEN_LOAD, error: true, payload }))
}

export function updateProps(updatedProps) {
    return dispatch => {
        return dispatch({ type: AGENTSURVEYSCREEN_SET, updatedProps });
    }
}
